// Action Types
export const FETCH_SPOT_CONTACTS_BC_REQUEST = "FETCH_SPOT_CONTACTS_BC_REQUEST";
export const FETCH_SPOT_CONTACTS_BC_SUCCESS = "FETCH_SPOT_CONTACTS_BC_SUCCESS";
export const FETCH_SPOT_CONTACTS_BC_FAILURE = "FETCH_SPOT_CONTACTS_BC_FAILURE";

// Action Types
export const FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST = "FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST";
export const FETCH_SPOT_CONTACTS_BC_PSYCO_SUCCESS = "FETCH_SPOT_CONTACTS_BC_PSYCO_SUCCESS";
export const FETCH_SPOT_CONTACTS_BC_PSYCO_FAILURE = "FETCH_SPOT_CONTACTS_BC_PSYCO_FAILURE";

export const RESET_SPOT_CONTACT_BC = "RESET_SPOT_CONTACT_BC";

// Action Creators
export const FetchSpotContactsBCRequest = ({contactId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SPOT_CONTACTS_BC_REQUEST,
      payload: { contactId },
    });
  };
};
export const FetchSpotContactsBCSuccess = (data) => ({
  type: FETCH_SPOT_CONTACTS_BC_SUCCESS,
  payload: data,
});
export const FetchSpotContactsBCFailure = (error) => ({
  type: FETCH_SPOT_CONTACTS_BC_FAILURE,
  payload: error,
});

// Actions for contact psycometric data
export const FetchSpotContactsBCPsycoRequest = ({contactId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SPOT_CONTACTS_BC_PSYCO_REQUEST,
      payload: { contactId },
    });
  };
};
export const FetchSpotContactsBCPsycoSuccess = (data) => ({
  type: FETCH_SPOT_CONTACTS_BC_PSYCO_SUCCESS,
  payload: data,
});
export const FetchSpotContactsBCPsycoFailure = (error) => ({
  type: FETCH_SPOT_CONTACTS_BC_PSYCO_FAILURE,
  payload: error,
});



export const resetSpotContactBC = () => ({
  type: RESET_SPOT_CONTACT_BC
});
